import BuyingFilter from "../../../components/filteration/buyingFilter";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import Shops from "../../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col, Pagination } from "react-bootstrap";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import BackArrow from "../../../components/backArrow";
import { useBuyWholesellerState } from "./useBuyWholesellerState";
import { WHOLESELLER_ALLOWED_CONNECT_TYPES } from "../../../constants/businessTypeConnectionRules";

const BuyWholeSaller = () => {
  const {
    isloading,
    createshopcategory,
    shopCategory,
    shopCategorytwo,
    showmodal,
    showshare,
    dataCategory,
    shopdata,
    itemmdata,
    filters,
    page,
    totalPages,
    handleClosemodal,
    handleShow,
    handleCloseshare,
    handleShowshare,
    Handledata,
    Mydata,
    Handleadditioanalshop,
    FilterHandler,
    FilterHandleritem,
    handlePageChange,
  } = useBuyWholesellerState();

  // Generate pagination items dynamically
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === page}
        onClick={() => handlePageChange(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="buying-page-mobile-back d-lg-none" />
        <Row className="buying-page-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                FilterHandleritem={FilterHandleritem}
                Handleadditioanalshop={Handleadditioanalshop}
                FilterHandler={FilterHandler}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="ps-2 pt-2 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/wholeseller-userprofile"
                title="WholeSeller"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
                isServerPaginated={true}
                allowedConnectBusinessTypes={WHOLESELLER_ALLOWED_CONNECT_TYPES}
              />

              {/* Dynamic Pagination Controls */}
              {totalPages > 1 && shopdata?.length > 0 && (
                <div className="d-flex justify-content-center mt-4 mb-4">
                  <Pagination>
                    <Pagination.First
                      onClick={() => handlePageChange(1)}
                      disabled={page === 1}
                    />
                    <Pagination.Prev
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                    />
                    {items}
                    <Pagination.Next
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={page === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuyWholeSaller;
